'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsurersHint = function InsurersHint(props) {
  return _react2.default.createElement(
    'div',
    { className: _style2.default['insurers-hint'] },
    _react2.default.createElement(
      'p',
      { className: _style2.default['insurers-hint__text-row'] },
      'Please select your hospital list. If you do not know your hospital list you can find it on the Vitality Member Zone.'
    ),
    _react2.default.createElement(
      'p',
      { className: _style2.default['insurers-hint__text-row'] },
      'You must see a consultant at a hospital which is on your hospital list, or, if you are on Consultant Select, you must attend a hospital listed on your chosen consultant\u2019s profile.'
    ),
    _react2.default.createElement(
      'p',
      { className: _style2.default['insurers-hint__text-row'] },
      'If you attend a hospital that is not on your hospital list, you will be liable for 40% of any hospital charges.'
    )
  );
};

exports.default = InsurersHint;


// WEBPACK FOOTER //
// ./components/search-bar/lib/components/insurers-hint.js